// The landing screen's pure helpers. core.md §7.6.
//
// Nothing new: the landing page picks a patient and a thread by exactly the
// rules the chat page itself uses, so it RE-EXPORTS them rather than restating
// them. A second definition of "which thread is the most recent" is a second
// thing to keep in step, and this screen exists only to hand the student to the
// other one.

export { patientName, threadAt } from '../Chat/Chat.shared.js';
export { PATIENT_SCOPE } from '../../hooks/useChat.js';
